import React from 'react';
import { datasetAdminUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DatasetManageAction = ({ code, disabled }) => (
  <RibbonMenu
    name="settings"
    icon="sliders"
    message="actions.manage"
    url={datasetAdminUrl({ code }, '#')}
    className="aridhia-dataset-manage-action"
    disabled={disabled}
  />
);

export default DatasetManageAction;
